import React, { useState, useEffect, useRef } from 'react';
import './styles/style-duelist-table.scss';
import {
    Button,
    Input,
    Media,
    Modal,
    Table, UncontrolledTooltip
} from "reactstrap";

import {
    formatDateTime
} from '../../../../utils/conversor';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { api } from 'services/api';
import { describeApiError } from 'services/apiErrorMessage';
import { downloadAuthenticatedFile, fetchAuthenticatedBlobUrl } from 'services/downloadFile';
import { registerLocale } from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';

import InputMask from 'react-input-mask';

//import dos icones de principal 


//loader
import CircularProgress from '@material-ui/core/CircularProgress';

registerLocale('pt-br', ptBR);

const useStyles = makeStyles((theme) => ({
    loadingPrimaryPhone: {
        textAlign: 'center',
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#C2641A', // Alterado de azul para Laranja Pax
        backgroundColor: '#f8f9fe',
        borderRadius: '4px',
        marginTop: '10px',
        boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15)',
        animation: '$pulse 1.5s infinite',
    },
    '@keyframes pulse': {
        '0%': {
            transform: 'scale(1)',
            opacity: 1,
        },
        '50%': {
            transform: 'scale(1.05)',
            opacity: 0.7,
        },
        '100%': {
            transform: 'scale(1)',
            opacity: 1,
        },
    },
    modal: {},
    paper: {},
    headerButton: {
        backgroundColor: '#C2641A',  
        color: '#fff',            
        border: 'none',           
        padding: '5px 10px',
        borderRadius: '4px',
        cursor: 'pointer',
        width: '100%',
        transition: 'background-color 0.3s ease', 
        '&:hover': {
            backgroundColor: '#a85616',  
        },
    },
    headerButtonClose:{
        backgroundColor: '#C2641A',  
        color: '#fff',            
        border: 'none',           
        padding: '5px 10px',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease', 
        '&:hover': {
            backgroundColor: '#D9534F',  
        },
    },
    tabModal: {
        color: '#fff',  
        padding: '6px 18px',
        cursor: 'pointer',
        borderRadius: '6px',
        '&.tab-modal-selected': {
            backgroundColor: '#C2641A', 
        },
        '&:hover': {
            backgroundColor: '#a85616', 
        },
    },
    tableRow: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: 'flex-end',
        padding: '10px 0',
        borderBottom: '1px solid #e9ecef',
        flexWrap: 'wrap',
    },
    tableCell: {
        flexGrow: 1,
        flexBasis: 0,
        display: 'flex',
        flexDirection: 'column',
        padding: '4px 8px',
    },
    tableTag: {
        fontSize: '0.75rem',
        color: '#525f7f',
        fontWeight: '700',
        marginBottom: '4px',
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
    },

    //edição dos campos principais
    tableValue: {
        color: '#172430',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontWeight: '500',
        fontSize: '0.875rem',
        backgroundColor: '#fff',
        padding: '6px 10px',
        borderRadius: '4px',
        minHeight: '34px',
        border: '1px solid #dee2e6',
        boxShadow: '0 1px 2px rgba(50,50,93,.06)',
    },

    //valores participantes
    tableValueParticipantes: {
        color: '#172430',
        backgroundColor: '#fff',
        padding: '8px 10px',
        fontWeight: '500',
        fontSize: '0.875rem',
        borderRadius: '4px',
        minHeight: '34px',
        border: '1px solid #dee2e6',
        boxShadow: '0 1px 2px rgba(50,50,93,.06)',
    },
    tableValue1: {
        fontWeight: '600',
        color: '#172430',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f6f9fc',
        padding: '6px 12px',
        marginBottom: '8px',
        borderRadius: '4px',
        minHeight: '48px',
        border: '1px solid #e9ecef',
    },
    tableValueCheckBox: {
        fontWeight: '600',
        color: '#172430',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f6f9fc',
        marginBottom: '8px',
        borderRadius: '4px',
        minHeight: '48px',
        border: '1px solid #e9ecef',
    },
    formControl: {
        margin: theme.spacing(0.5),
        minWidth: '100px',
        maxWidth: '180px',
        maxHeight: '32px',
        width: '100%',
        padding: '0 4px',
        backgroundColor: '#fff',
        borderRadius: '4px',
        border: '1px solid #d2d6dc',
        transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            borderColor: '#C2641A',
        },
        '&:focus-within': {
            borderColor: '#C2641A',
            boxShadow: '0 0 0 2px rgba(194, 100, 26, 0.2)',
        },
        '& .MuiSelect-root': {
            padding: '4px 8px',
            fontSize: '0.8rem',
        },
        '& .MuiOutlinedInput-input': {
            padding: '2px 4px',
        },
    },
    actionButton: {
        cursor: 'pointer',
    },
    actionButtonSave: {
        cursor: 'pointer',
        margin: '10px auto',
        display: 'block',
    },
    actionButtonDelete: {
        cursor: 'pointer',
        marginRight: 'auto',
    },
    selectStatus: {
        backgroundColor: '#f9f9f9',  
        borderRadius: '4px',
        padding: '8px',
    },
    updateField: {
        backgroundColor: '#f9f9f9',  
        border: '1px solid #ddd',  
        borderRadius: '4px',  
        padding: '8px',
        marginBottom: '10px',
        '& label': {
            fontWeight: 'bold',
            textTransform: 'uppercase',
            marginBottom: '4px',
            color: '#555',
        },
        '& input': {
            padding: '6px 8px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            width: '100%',
        },
    },
    button: {
        cursor: 'pointer',
        marginRight: '5px',
    },
    fileContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '8px',
        padding: '10px 14px',
        backgroundColor: '#f6f9fc',
        borderRadius: '6px',
        border: '1px solid #e9ecef',
    },
    fileHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '6px',
        fontWeight: '600',
        fontSize: '0.9rem',
        color: '#172430',
    },
    fileActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
    },
    fileDescription: {
        fontSize: '0.85rem',
        color: '#525f7f',
        marginBottom: '4px',
    },
    fileDate: {
        fontSize: '0.75rem',
        color: '#8898aa',
    },
    phoneRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
    },
    hiddenCheckbox: {
        display: 'none',
    },
    iconLabel: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        marginRight: '10px',
    },
    checkIcon: {
        color: '#4caf50', // Verde para ícone de correto
        fontSize: '24px',
    },
    closeIcon: {
        color: '#f44336', // Vermelho para ícone de X
        fontSize: '24px',
    },

    // CSS DA NOVA PARTE DE ANEXOS E NEGOCIAÇÃO 
    notesContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: '12px 0 8px',
        marginTop: '8px',
        borderTop: '1px solid #e9ecef',
    },
    noteItem: {
        width: '100%',
        marginBottom: '10px',
        backgroundColor: '#f6f9fc',
        border: '1px solid #e9ecef',
        borderRadius: '6px',
    },
    noNotesMessage: {
        textAlign: 'center',
        fontSize: '1rem',
        color: '#888',
        width: '100%',
    },
    noteInputContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '10px',
        borderTop: '1px solid #ddd',
        paddingTop: '10px',
        width: '100%',
    },
    noteInput: {
        flexGrow: 1,
        marginRight: '10px',
    },
    noteSubmitButton: {
        flexShrink: 0,
    },
    //notas
    container_register_note_duelist_modal: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    box_register_note_duelist_modal: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '600px',
        backgroundColor: '#ffffff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        '& button': {
            width: '100px',
            marginBottom: '15px',
            backgroundColor: '#C2641A',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
            '&:hover': {
                backgroundColor: '#a85616',
            },
        },
        '& textarea': {
            width: '100%',
            minHeight: '100px',
            padding: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            marginTop: '10px',
            resize: 'vertical',
            boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)',
            '&:focus': {
                borderColor: '#C2641A',
                outline: 'none',
                boxShadow: '0 0 5px rgba(194, 100, 26, 0.5)',
            },
        },
    }
    
}));




export const THeadRow = () => (
    <tr>
        <th scope="col">Nº</th>
        <th scope="col">Número do processo</th>
        <th scope="col">Requerente</th>
        <th scope="col">Advogado</th>
        <th scope="col">Valor</th>
        <th scope="col">Ano</th>
        <th scope="col">Status</th>
        <th scope="col">Atribuído</th>
        <th scope="col">Ações</th>
    </tr>
);


const RenderMediaList = (props) => {
    return (
        <Media className="align-items-center">
            <Media>
                <span id={`order-${props.index}-${props.id}`} className="custom-duelist-span">
                    {props.data?props.data:null}
                </span>
                <UncontrolledTooltip
                    delay={0}
                    placement="bottom"
                    target={`order-${props.index}-${props.id}`}
                >
                    {props.data?props.data:null}
                </UncontrolledTooltip>
            </Media>
        </Media>
    )
}

export const RowCells = (props) => {
    return <RowList {...props} asCells={true} />;
};

const RowList = (props) => {
    const notify = props.showToast || (() => {});
    const classes = useStyles();
    const { order, reload, endpoint, i, users, onOpenModal } = props;
    const [selectedUser] = useState(order.user_associated);

    const [ manualUserMode, setManualUserMode ] = useState(false);
    const handleManualUserMode = () => setManualUserMode(!manualUserMode);

    const openModal = onOpenModal || (() => {});
    const handleSelectUser = async (e) => {
        try {
            await api.patch(`/process/${order.id}/`, { user_associated: e.target.value});
            await reload(endpoint, {loader: false});
            notify("success", "Sucesso ao atribuir usuário ao precatório");
        } catch (error) {
            console.error(error);
            notify("error", describeApiError(error));
        } finally {
            handleManualUserMode();
        }
    }

    const userIsAdmin = () => {
        const userId = localStorage.getItem('AUTHOR_ID');
        const userData = users.find((user) => user.id === parseInt(userId));
        if(!userData) return false;
        return userData.is_superuser;
    }

    const changeProcessUser= async () => {
        const user = localStorage.getItem('AUTHOR_ID');
        try {
            await api.patch(`/process/${order.id}/`, { user_associated: user });
            await reload(endpoint, {loader: false});
            notify("success", "Sucesso na atribuição desta ordem");
        } catch (error) {
            console.error(error);
            notify("error", describeApiError(error));
        }
    }
    const [confirmAssign, setConfirmAssign] = useState(false);
    const confirmTimeoutRef = useRef(null);

    const handleAssignClick = () => {
        if (userIsAdmin()) return handleManualUserMode();
        if (!userIsAdmin() && order.user_associated) return;
        setConfirmAssign(true);
        // Auto-cancela a confirmação após 4s
        if (confirmTimeoutRef.current) clearTimeout(confirmTimeoutRef.current);
        confirmTimeoutRef.current = setTimeout(() => setConfirmAssign(false), 4000);
    }

    const confirmAndAssignUser = async () => {
        if (confirmTimeoutRef.current) clearTimeout(confirmTimeoutRef.current);
        try {
            await changeProcessUser();
            setConfirmAssign(false);
        } catch (error) {
            console.error(error);
            notify("error", describeApiError(error));
            setConfirmAssign(false);
        }
    }

    const getAssignButtonClass = () => {
        if (confirmAssign) return 'assign-btn assign-btn-confirm';
        if (order.user_associated) {
            return userIsAdmin() ? 'assign-btn assign-btn-assigned-admin' : 'assign-btn assign-btn-assigned';
        }
        return 'assign-btn assign-btn-available';
    }

    const getAssignedUserName = () => {
        if (!order.user_associated_data) return '';
        const { is_superuser, username, first_name, last_name } = order.user_associated_data;
        return is_superuser ? username : `${first_name} ${last_name}`;
    }

    const cells = (
        <>
            <td>
                    <Media className="align-items-center">
                        <Media>
                            {order.situation !== 'undefined' ? (
                                <div style={{ color: '#525f7f', fontWeight: '600' }}>
                                    <span className="text-sm">{i + 1}</span>
                                </div>
                            ) : (
                                <div style={{ color: '#adb5bd', fontWeight: '400' }}>
                                    <span className="text-sm">{i + 1}</span>
                                </div>
                            )}
                        </Media>
                    </Media>
                </td>
                <td>
                    <RenderMediaList index={i} id={`process_number-${order.id}`} data={order.process_number} />
                </td>
                <td>
                    <RenderMediaList index={i} id={`titular-${order.id}`} data={order.titular} />
                </td>
                <td>
                    <RenderMediaList index={i} id={`lawyer-${order.id}`} data={order.lawyer} />
                </td>
                <td>
                    <RenderMediaList index={i} id={`value-${order.id}`}
                        data={(order.value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                    />
                </td>
                <td>
                    <RenderMediaList index={i} id={`proposal_year-${order.id}`} data={order.proposal_year} />
                </td>
                <td>
                    <RenderMediaList index={i} id={`order-${order.id}-status`}
                        data={order.status?.length > 0 ? order.status[0].status_data.name : "Não Trabalhado"}
                    />
                </td>
                {/* código botão funcional pegar processo
                <td>
                    <Button 
                        size='sm' 
                        color={confirmAssign ? 'success' : 'default'}
                        onClick={
                            order.user_associated 
                                ? (confirmAssign ? confirmAndAssignUser : handleAssignClick) // Para o caso de "Assumir"
                                : (confirmAssign ? confirmAndAssignUser : handleAssignClick) // Para o caso de "Confirmar"
                        }
                        onMouseOut={() => setConfirmAssign(false)}
                    >
                        {order.user_associated 
                            ? (confirmAssign 
                                ? 'Assumir' 
                                : (order.user_associated_data.is_superuser 
                                    ? order.user_associated_data.username 
                                    : `${order.user_associated_data.first_name} ${order.user_associated_data.last_name}`
                                )
                            ) 
                            : (confirmAssign ? 'Confirmar' : 'Atribuir')}
                    </Button>
                </td> */}
                <td>
                    {!manualUserMode ? (
                        <>
                            <Button
                                id={`assign-btn-${order.id}`}
                                size="sm"
                                className={getAssignButtonClass()}
                                color={confirmAssign ? 'success' : (order.user_associated ? 'secondary' : 'primary')}
                                onClick={confirmAssign ? confirmAndAssignUser : handleAssignClick}
                                style={{ 
                                    minWidth: '100px',
                                    padding: '4px 8px',
                                    fontSize: '0.75rem'
                                }}
                            >
                                {order.user_associated
                                    ? getAssignedUserName()
                                    : (confirmAssign ? '✓ Confirmar' : 'Atribuir')}
                            </Button>
                            {order.user_associated && (
                                <UncontrolledTooltip
                                    delay={0}
                                    target={`assign-btn-${order.id}`}
                                >
                                    {userIsAdmin()
                                        ? `${getAssignedUserName()} — clique para reatribuir`
                                        : getAssignedUserName()}
                                </UncontrolledTooltip>
                            )}
                            {!order.user_associated && !confirmAssign && (
                                <UncontrolledTooltip
                                    delay={0}
                                    target={`assign-btn-${order.id}`}
                                >
                                    Clique para atribuir a você
                                </UncontrolledTooltip>
                            )}
                        </>
                    ):(
                        <FormControl required className={classes.formControl}>
                            <Select
                                labelId={`select-user-label-${order.id}`}
                                id={`select-user-${order.id}`}
                                value={selectedUser}
                                onChange={handleSelectUser}
                                MenuProps={{
                                    PaperProps: {
                                        style: { maxHeight: 300 },
                                    },
                                }}
                            >
                                <MenuItem value="">
                                    <em>Nenhum</em>
                                </MenuItem>
                                {users.map((userData) => (
                                    <MenuItem key={`user-item-${userData.id}`} value={userData.id}>
                                        {userData.is_superuser ? userData.username : `${userData.first_name} ${userData.last_name}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </td>
                <td>
                    <Media className="align-items-center">
                        <Media>
                            <Button outline size="sm" color="primary" onClick={openModal}>
                                Detalhes
                            </Button>
                        </Media>
                    </Media>
                </td>
        </>
    );

    // Único modo em uso: células para o TableVirtuoso. O modal de detalhe é
    // renderizado fora da lista pelo componente pai (Duelist); o TableModal
    // antigo era código morto e saiu (#10).
    return <>{cells}</>;
}
